import React, { useRef } from "react";
import SunEditor from "suneditor-react";
import SunEditorCore from "suneditor/src/lib/core";
import "suneditor/dist/css/suneditor.min.css";
interface props {
    value: any
    onChange: (value: string) => void;
    isDisable?: any
}
const TextEditor = ({ value, onChange, isDisable, }: props) => {
    const editor = useRef<SunEditorCore | null>(null);
    const getSunEditorInstance = (sunEditor: SunEditorCore) => {
        editor.current = sunEditor;
    };
    const defaultFonts = [
        "Arial",
        "Comic Sans MS",
        "Courier New",
        "Impact",
        "Georgia",
        "Tahoma",
        "Trebuchet MS",
        "Verdana",
    ];

    const sortedFontOptions = [
        "Logical",
        "Salesforce Sans",
        "Garamond",
        "Sans-Serif",
        "Serif",
        "Times New Roman",
        "Helvetica",
        ...defaultFonts,
    ].sort();
    return (
        <div className='bxshadow p-2 borderRadius mb-4'>
            <SunEditor getSunEditorInstance={getSunEditorInstance}
                setOptions={{
                    buttonList: [
                        ["font", "fontSize", "formatBlock"],
                        [
                            "bold",
                            "underline",
                            "italic",
                            "strike",
                            "subscript",
                            "superscript",
                        ],
                        ["fontColor", "hiliteColor"],
                        ["align", "horizontalRule", "list", "table"],
                        ["outdent", "indent"],
                        ["undo", "redo"],
                        ["removeFormat"],
                        ["outdent", "indent"],
                        ["link", "image"],
                        ["showBlocks", "codeView", "save"],
                    ],
                    defaultTag: "div",
                    showPathLabel: false,
                    font: sortedFontOptions,
                }}
                defaultValue={value}
                setContents={value}
                // onSave={(value:any) => onChange(value)}
                onChange={onChange}
                disable={isDisable} />
        </div>
    );
};

export default TextEditor;
